import { Component, Input, OnInit } from '@angular/core';
import { FormatHelper } from 'src/app/helpers';
import { SurveyQuestion, SurveyRadioTableAnswer } from 'src/app/models/survey';

@Component({
  selector: 'app-comments-list',
  templateUrl: './comments-list.component.html',
  styleUrls: ['./comments-list.component.css']
})
export class CommentsListComponent implements OnInit {

  @Input()
  question: SurveyQuestion<SurveyRadioTableAnswer>|null = null;

  constructor() { }

  ngOnInit(): void {
  }

  letter(index: number) {
    return FormatHelper.letter(index);
  }

  countNonEmpty(values: string[]) {
    return values?.length ? values.filter(v => v && v.trim()).length : 0;
  }
}
